// import React, { useState, useRef } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Pagination,
//   Select,
//   MenuItem,
//   FormControl,
//   IconButton,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions
// } from "@mui/material";

// import SearchIcon from "@mui/icons-material/Search";
// import AddIcon from "@mui/icons-material/Add";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import SaveIcon from "@mui/icons-material/Save";
// import CloseIcon from "@mui/icons-material/Close";
// import ImportExportIcon from "@mui/icons-material/ImportExport";

// import "./FmAttendanceTable.css";

// const EmployeeAttendanceTable = () => {
//   const [employees, setEmployees] = useState([]);
//   const [search, setSearch] = useState("");
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [page, setPage] = useState(1);

//   const [open, setOpen] = useState(false);
//   const [mode, setMode] = useState("add"); // add | edit | view
//   const [formData, setFormData] = useState({});
//   const importRef = useRef(null);

//   /* ---------- SEARCH ---------- */
//   const filtered = employees.filter(
//     (e) =>
//       e.name?.toLowerCase().includes(search.toLowerCase()) ||
//       e.id?.toString().includes(search)
//   );

//   const count = Math.ceil(filtered.length / rowsPerPage);

//   /* ---------- IMPORT ---------- */
//   const handleImport = () => importRef.current.click();

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onload = (ev) => {
//       const rows = ev.target.result.split("\n").slice(1);
//       const data = rows
//         .map((r) => {
//           const v = r.split(",");
//           return {
//             id: v[0],
//             name: v[1]?.replace(/"/g, ""),
//             absentDate: v[2],
//             absentDays: v[3],
//             anomalies: v[4]?.replace(/"/g, ""),
//             lopDays: v[5],
//           };
//         })
//         .filter((e) => e.id);

//       setEmployees((prev) => [...data, ...prev]);
//     };
//     reader.readAsText(file);
//   };

//   /* ---------- EXPORT ---------- */
//   const handleExport = () => {
//     const header = [
//       "Employee ID",
//       "Name",
//       "Absent Date",
//       "Absent Days",
//       "Anomalies",
//       "LOP Days",
//     ];

//     const csv = [
//       header.join(","),
//       ...employees.map((e) =>
//         [e.id, `"${e.name}"`, e.absentDate, e.absentDays, `"${e.anomalies}"`, e.lopDays].join(",")
//       ),
//     ].join("\n");

//     const blob = new Blob([csv], { type: "text/csv" });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = "attendance.csv";
//     link.click();
//   };

//   /* ---------- CRUD ---------- */
//   const openModal = (type, data = {}) => {
//     setMode(type);
//     setFormData(data);
//     setOpen(true);
//   };

//   const saveEmployee = () => {
//     if (mode === "add") {
//       setEmployees([{ ...formData, id: Date.now() }, ...employees]);
//     } else if (mode === "edit") {
//       setEmployees(employees.map((e) => (e.id === formData.id ? formData : e)));
//     }
//     setOpen(false);
//   };

//   const deleteEmployee = (id) => {
//     if (window.confirm("Delete this record?")) {
//       setEmployees(employees.filter((e) => e.id !== id));
//     }
//   };

//   return (
//     <div className="attendance-wrapper">
//       <input type="file" hidden ref={importRef} accept=".csv" onChange={handleFileUpload} />

//       {/* HEADER */}
//       <div className="attendance-header">
//         <h2>Employee Attendance</h2>

//         <div className="header-right">
//           <div className="search-box">
//             <SearchIcon />
//             <input
//               placeholder="Search employee..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//           </div>

//           <Button className="btn import" onClick={handleImport}>
//             <ImportExportIcon /> Import
//           </Button>

//           <Button className="btn export" onClick={handleExport}>
//             <ImportExportIcon /> Export
//           </Button>

//           <Button className="btn add" onClick={() => openModal("add")}>
//             <AddIcon /> Add
//           </Button>
//         </div>
//       </div>

//       {/* TABLE */}
//       <TableContainer component={Paper} className="table-box">
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>ID</TableCell>
//               <TableCell>Name</TableCell>
//               <TableCell>Absent Date</TableCell>
//               <TableCell>Days</TableCell>
//               <TableCell>LOP</TableCell>
//               <TableCell align="center">Actions</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {filtered
//               .slice((page - 1) * rowsPerPage, page * rowsPerPage)
//               .map((row) => (
//                 <TableRow key={row.id}>
//                   <TableCell>{row.id}</TableCell>
//                   <TableCell>{row.name}</TableCell>
//                   <TableCell>{row.absentDate}</TableCell>
//                   <TableCell>{row.absentDays}</TableCell>
//                   <TableCell>{row.lopDays}</TableCell>
//                   <TableCell align="center">
//                     <IconButton onClick={() => openModal("view", row)}>
//                       <VisibilityIcon />
//                     </IconButton>
//                     <IconButton onClick={() => openModal("edit", row)}>
//                       <EditIcon />
//                     </IconButton>
//                     <IconButton onClick={() => deleteEmployee(row.id)}>
//                       <DeleteIcon />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* PAGINATION */}
//       <div className="pagination-box">
//         <FormControl size="small">
//           <Select value={rowsPerPage} onChange={(e) => setRowsPerPage(e.target.value)}>
//             <MenuItem value={5}>5</MenuItem>
//             <MenuItem value={10}>10</MenuItem>
//             <MenuItem value={25}>25</MenuItem>
//           </Select>
//         </FormControl>

//         <Pagination count={count} page={page} onChange={(e, v) => setPage(v)} />
//       </div>

//       {/* MODAL */}
//       <Dialog open={open} fullWidth maxWidth="sm">
//         <DialogTitle>
//           {mode === "view" ? "View Attendance" : "Employee Attendance"}
//         </DialogTitle>

//         <DialogContent className="modal-grid">
//           {["name", "absentDate", "absentDays", "anomalies", "lopDays"].map((f) => (
//             <TextField
//               key={f}
//               label={f}
//               type={f.includes("Date") ? "date" : "text"}
//               value={formData[f] || ""}
//               onChange={(e) => setFormData({ ...formData, [f]: e.target.value })}
//               InputLabelProps={{ shrink: true }}
//               disabled={mode === "view"}
//             />
//           ))}
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={() => setOpen(false)} startIcon={<CloseIcon />}>
//             Close
//           </Button>
//           {mode !== "view" && (
//             <Button onClick={saveEmployee} startIcon={<SaveIcon />}>
//               Save
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default EmployeeAttendanceTable;


import React, { useState, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Pagination,
  Select,
  MenuItem,
  FormControl,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ImportExportIcon from "@mui/icons-material/ImportExport";

import "./FmAttendanceTable.css";

const EmployeeAttendanceTable = () => {
  const [employees, setEmployees] = useState([
    {
      id: 1,
      name: "Vikash Kumar",
      absentDate: "2026-02-01",
      absentDays: "2",
      anomalies: "None",
      lopDays: "0",
    },
    {
      id: 2,
      name: "Naresh Bojja",
      absentDate: "2026-01-28",
      absentDays: "1",
      anomalies: "Late entry",
      lopDays: "0",
    },
  ]);

  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(1);

  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("add"); // add | edit | view
  const [formData, setFormData] = useState({});
  const importRef = useRef(null);

  /* ---------- SEARCH ---------- */
  const filtered = employees.filter(
    (e) =>
      e.name?.toLowerCase().includes(search.toLowerCase()) ||
      e.id?.toString().includes(search)
  );

  const count = Math.ceil(filtered.length / rowsPerPage);

  /* ---------- IMPORT ---------- */
  const handleImport = () => importRef.current.click();

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (ev) => {
      const rows = ev.target.result.split("\n").slice(1);
      const data = rows
        .map((r) => {
          const v = r.split(",");
          return {
            id: v[0],
            name: v[1]?.replace(/"/g, ""),
            absentDate: v[2],
            absentDays: v[3],
            anomalies: v[4]?.replace(/"/g, ""),
            lopDays: v[5],
          };
        })
        .filter((e) => e.id);

      setEmployees((prev) => [...data, ...prev]);
    };
    reader.readAsText(file);
  };

  /* ---------- EXPORT ---------- */
  const handleExport = () => {
    const header = [
      "Employee ID",
      "Employee Name",
      "Absent Date",
      "Absent Days",
      "Outstanding Anomalies",
      "LOP Days",
    ];

    const csv = [
      header.join(","),
      ...employees.map((e) =>
        [
          e.id,
          `"${e.name}"`,
          e.absentDate,
          e.absentDays,
          `"${e.anomalies}"`,
          e.lopDays,
        ].join(",")
      ),
    ].join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "employee_attendance.csv";
    link.click();
  };

  /* ---------- CRUD ---------- */
  const openModal = (type, data = {}) => {
    setMode(type);
    setFormData(data);
    setOpen(true);
  };

  const saveEmployee = () => {
    if (mode === "add") {
      setEmployees([{ ...formData, id: Date.now() }, ...employees]);
    } else if (mode === "edit") {
      setEmployees(
        employees.map((e) => (e.id === formData.id ? formData : e))
      );
    }
    setOpen(false);
  };

  const deleteEmployee = (id) => {
    if (window.confirm("Delete this record?")) {
      setEmployees(employees.filter((e) => e.id !== id));
    }
  };

  return (
    <div className="attendance-wrapper">
      <input
        type="file"
        hidden
        ref={importRef}
        accept=".csv"
        onChange={handleFileUpload}
      />

      {/* HEADER */}
      <div className="attendance-header">
        <h2>Employee Attendance</h2>

        <div className="header-right">
          <div className="search-box">
            <SearchIcon />
            <input
              placeholder="Search employee..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <Button className="btn import" onClick={handleImport}>
            <ImportExportIcon /> Import
          </Button>

          <Button className="btn export" onClick={handleExport}>
            <ImportExportIcon /> Export
          </Button>

          <Button className="btn add" onClick={() => openModal("add")}>
            <AddIcon /> Add
          </Button>
        </div>
      </div>

      {/* TABLE */}
      <TableContainer component={Paper} className="table-box">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Employee ID</TableCell>
              <TableCell>Employee Name</TableCell>
              <TableCell>Absent Date</TableCell>
              <TableCell>Absent Days</TableCell>
              <TableCell>Outstanding Anomalies</TableCell>
              <TableCell>LOP Days</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filtered
              .slice((page - 1) * rowsPerPage, page * rowsPerPage)
              .map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.absentDate}</TableCell>
                  <TableCell>{row.absentDays}</TableCell>
                  <TableCell>{row.anomalies}</TableCell>
                  <TableCell>{row.lopDays}</TableCell>
                  <TableCell align="center">
                    <IconButton onClick={() => openModal("view", row)}>
                      <VisibilityIcon />
                    </IconButton>
                    <IconButton onClick={() => openModal("edit", row)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => deleteEmployee(row.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* PAGINATION */}
      <div className="pagination-box">
        <FormControl size="small">
          <Select
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(e.target.value)}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
          </Select>
        </FormControl>

        <Pagination
          count={count}
          page={page}
          onChange={(e, v) => setPage(v)}
        />
      </div>

      {/* MODAL */}
      <Dialog open={open} fullWidth maxWidth="sm">
        <DialogTitle>
          {mode === "view" ? "View Attendance" : "Employee Attendance"}
        </DialogTitle>

        <DialogContent className="modal-grid">
          {[
            "name",
            "absentDate",
            "absentDays",
            "anomalies",
            "lopDays",
          ].map((f) => (
            <TextField
              key={f}
              label={
                f === "name"
                  ? "Employee Name"
                  : f === "absentDays"
                  ? "Absent Days"
                  : f === "lopDays"
                  ? "LOP Days"
                  : f === "anomalies"
                  ? "Outstanding Anomalies"
                  : "Absent Date"
              }
              type={f.includes("Date") ? "date" : "text"}
              value={formData[f] || ""}
              onChange={(e) =>
                setFormData({ ...formData, [f]: e.target.value })
              }
              InputLabelProps={{ shrink: true }}
              disabled={mode === "view"}
              fullWidth
              margin="dense"
            />
          ))}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)} startIcon={<CloseIcon />}>
            Close
          </Button>
          {mode !== "view" && (
            <Button onClick={saveEmployee} startIcon={<SaveIcon />}>
              Save
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default EmployeeAttendanceTable;

